<div class="eiq-checkbox-group">
  @if (label()) {
    <span class="text__sm fw__500 label">
      {{ label() }}
      @if (tooltip()) {
        <fa-icon [icon]="faInfoCircle" class="caption" [matTooltip]="tooltip()"></fa-icon>
      }
    </span>
  }
  <div class="eiq-checkbox-group__list" [class.expand]="expand()" [attr.data-testid]="testId() ? testId() + '-checkbox-group' : null">
    @for (option of options(); track option.value) {
      <mat-checkbox
        [color]="color()"
        [checked]="this.formCtrl()?.value?.includes(option.value)"
        [attr.data-testid]="testId() ? testId() + '-option-' + $index + '-checkbox' : null"
        (change)="mapChecked(option)"
      >
        <div class="survey-viewer__html-content text__sm label">{{ option.text }}</div>
      </mat-checkbox>
    }
  </div>
</div>
